import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { BannerType, BannerView } from "@dotnet/telematics-design-system";

import { noop } from "shared/functions";
import { useScroll } from "shared/hooks/useScroll";
import { DEVICE_STATISTICS } from "shared/types/enums";

import { DrawerLabel, SingleDeviceStatsItem } from "./components";
import { DeviceStatisticsContentProps } from "./types";

const DeviceStatisticsContent = ({
    contentPadding,
    onScroll,
    permanentBorder
}: DeviceStatisticsContentProps) => {
    const { t } = useTranslation();

    const { scrollTop, handleScroll } = useScroll();

    const deviceStatsQueries = Object.values(DEVICE_STATISTICS);

    return (
        <>
            <DrawerLabel
                scrollTop={scrollTop}
                permanentBorder={permanentBorder}
            />

            <div
                onScroll={onScroll ? handleScroll : noop}
                css={css({
                    overflowY: "scroll",
                    padding: contentPadding,
                    overflowX: "hidden",
                    position: "relative"
                })}
            >
                <BannerView
                    bannerType={BannerType.Info}
                    title={t("Statistics##statistics message")}
                />

                {deviceStatsQueries.map(
                    (query: DEVICE_STATISTICS, index: number) => (
                        <SingleDeviceStatsItem
                            key={query}
                            query={query}
                            isLast={deviceStatsQueries.length - 1 === index}
                        />
                    )
                )}
            </div>
        </>
    );
};

export default DeviceStatisticsContent;
